<div class="auth-container">
    <div class="auth-glass-container vh-100 m-auto">
        <img src="../../../assets/img/calimax_logo_square.svg"
             class="m-auto"
             [height]="64"
             alt="Caliwallet Logo">
        <div class="auth-content-area card-theme-color">
            <div class="flex-grow-1">
                <div class="login-background">
                    <div class="login-mark-background h-100 w-100"
                         [class.d-flex]="!isMobile">
                        <div [class.py-3]="isMobile" id="login-container">
                            <div class="tabs-container">
                                <div [hidden]="userNeedsRecovery">
                                    <mat-tab-group [selectedIndex]="selectedIndex" [disableRipple]="true">
                                        <mat-tab label="Acceso">
                                            <app-login (userNeedsRecovery)="displayRecovery()"></app-login>
                                        </mat-tab>
                                        <mat-tab label="Registro">
                                            <app-signup (onUserActivation)="getTabIndex($event)"></app-signup>
                                        </mat-tab>
                                    </mat-tab-group>
                                </div>
                                <ng-container *ngIf="userNeedsRecovery">
                                    <app-password-reset
                                        (userCancelRecovery)="userNeedsRecovery = !userNeedsRecovery"
                                        (userCompletedRecovery)="userNeedsRecovery = false">
                                    </app-password-reset>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
